import { Box, HStack, Stack, Td, Text, Th, Tr, VStack } from '@chakra-ui/react';
import { useAuth, usePagination } from 'core';
import { useFetchAfesPageQuery } from '../../api';
import { AppTable } from '../table';
import { AfeLink, CurrencyLabel, MultiBar } from 'features';
import { useMemo } from 'react';
import Decimal from 'decimal.js';

export interface AfeSearchPageProps {}

export const AfeSearchPage = (props: AfeSearchPageProps) => {
  const auth = useAuth();
  const [page, setPagination] = usePagination();
  const { data: afes, isLoading } = useFetchAfesPageQuery(
    {
      ...page,
      clientId: auth?.user?.clientId ?? '0',
    },
    {
      skip: !auth,
    }
  );

  let body = (
    <>
      <Tr>
        <Td colSpan={6}>Loading...</Td>
      </Tr>
    </>
  );

  //   <Th>AFE</Th>
  // <Th>Budget</Th>
  // <Th>Contingency</Th>
  // <Th>Commitment</Th>
  // <Th>Invoiced</Th>
  // <Th>Remaining Budget</Th>
  // <Th>Remaining Commitment</Th>
  // <Th>EAC</Th>
  // <Th>Over/Under Budget</Th>

  const alteredItems = useMemo(() => {
    return afes?.items.map((afe) => {
      // Primitives
      const calcApprovedBudget = new Decimal(afe.totalBudget);
      const calcApprovedContingency = new Decimal(afe.totalContingency);
      const calcApprovedCommitment = new Decimal(afe.totalCommitment);
      const calcApprovedInvoiced = new Decimal(afe.totalInvoiced);
      const calcPendingBudget = new Decimal(afe.pendingBudget);
      const calcPendingContingency = new Decimal(afe.pendingContingency);
      const calcPendingCommitment = new Decimal(afe.pendingCommitment);
      const calcPendingInvoice = new Decimal(afe.pendingInvoiced);

      // Totals
      const calcTotalBudget = calcApprovedBudget.add(calcPendingBudget);
      const calcTotalContingency = calcApprovedContingency.add(
        calcPendingContingency
      );
      // const calcTotalBudgetAndContingency =
      //   calcTotalBudget.add(calcTotalContingency);
      const calcTotalCommitment = calcApprovedCommitment.add(
        calcPendingCommitment
      );
      const calcTotalInvoice = calcApprovedInvoiced.add(calcPendingInvoice);
      const calcTotalConsumed = new Decimal(
        Math.max(calcTotalCommitment.toNumber(), calcTotalInvoice.toNumber())
      );

      // Remainings
      const calcRawRemainingBudget = calcTotalBudget.sub(calcTotalCommitment);
      const calcRemainingBudget = new Decimal(
        Math.max(0, calcRawRemainingBudget.toNumber())
      );
      const calcRawRemainingCommitment =
        calcTotalCommitment.sub(calcTotalInvoice);
      const calcRemainingCommitment = new Decimal(
        Math.max(0, calcRawRemainingCommitment.toNumber())
      );

      return {
        ...afe,
        calcTotalBudget,
        calcTotalContingency,
        // calcTotalBudgetAndContingency,
        calcTotalCommitment,
        calcTotalInvoice,
        calcTotalConsumed,
        calcRemainingBudget,
        // calcRemainingContingency,
        calcRemainingCommitment,
      };
    });
  }, [afes?.items]);

  if (!isLoading) {
    body = (
      <>
        {alteredItems?.map((afe, i) => (
          <Tr key={i}>
            <Td>
              <AfeLink afe={afe} />
            </Td>
            {/* <Th>AFE</Th>
            <Th>Budget</Th>
            <Th>Contingency</Th>
            <Th>Commitment</Th>
            <Th>Invoiced</Th>
            <Th>Remaining Budget</Th>
            <Th>Remaining Commitment</Th>
            <Th>EAC</Th>
            <Th>Over/Under Budget</Th> */}
            <Td>
              <CurrencyLabel value={afe.calcTotalBudget} />
            </Td>
            <Td>
              <CurrencyLabel value={afe.calcTotalContingency} />
            </Td>
            <Td>
              <MultiBar
                max={[afe.calcTotalBudget]}
                values={[afe.calcTotalCommitment]}
              />
            </Td>
            <Td>
              <MultiBar
                max={[afe.calcTotalBudget]}
                values={[afe.calcTotalInvoice]}
              />
            </Td>
            <Td>
              <MultiBar
                max={[afe.calcTotalBudget]}
                values={[afe.calcRemainingBudget]}
              />
            </Td>
            <Td>
              <MultiBar
                max={[afe.calcTotalBudget]}
                values={[afe.calcRemainingCommitment]}
              />
            </Td>
          </Tr>
        ))}
      </>
    );
  }

  return (
    <Box>
      <Stack>
        <AppTable
          title="Search AFE's"
          body={body}
          header={
            <>
              <Tr>
                <Th>AFE</Th>
                <Th>Budget</Th>
                <Th>Contingency</Th>
                <Th>Commitment</Th>
                <Th>Invoiced</Th>
                <Th>Remaining Budget</Th>
                <Th>Remaining Commitment</Th>
                {/* <Th>EAC</Th> */}
                {/* <Th>Over/Under Budget</Th> */}
              </Tr>
            </>
          }
          pagination={{
            ...page,
            itemCount: Number(afes?.itemCount ?? 0),
            pageCount: Number(afes?.pageCount ?? 0),
          }}
          onPaginationChange={setPagination}
        />
      </Stack>
    </Box>
  );
};
